export default {
	path: 'projects',
	component: () => import('@/views/projects/Index'),
	children: [
		{
			path: '',
			name: 'ProjectsList',
			component: () => import('@/views/projects/ProjectsList'),
			meta: {
				title: 'Projects',
			},
		},
	],
};
